import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-input-2/lib/style.css";
import Navigation from './navigation';
import { toast, ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { onMessage } from 'firebase/messaging';
import { useDispatch } from 'react-redux';
import Notify from './components/Common/Notify';
import { requestPermissionAndGetToken, messaging } from './Services/firebaseMessaging';

const App = () => {
  const dispatch = useDispatch();
  const [payload, setPayload] = useState<any>(null);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [currentNotification, setCurrentNotification] = useState<any>(null);

  useEffect(() => {
    requestPermissionAndGetToken(dispatch);

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Message received. ", payload);
      if (payload) {
        setPayload(payload)
      }
    });
    return () => unsubscribe();
  }, [dispatch]);

  useEffect(() => {
    navigator.serviceWorker.ready.then(() => {
      navigator.serviceWorker.addEventListener("message", (event) => {
        console.log("✅ message event from SW:", event.data);
        if (event.data) {
          setNotifications(prev => [...prev, event.data]);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (!currentNotification && notifications.length > 0) {
      setCurrentNotification(notifications[0]);
      setNotifications(prev => prev.slice(1));
    }
  }, [notifications, currentNotification]);

  return (
    <>
      <div className="App">
        <Navigation />
        <ToastContainer />
      </div>
      {currentNotification && (
        <Notify
          payload={currentNotification}
          onClose={() => setCurrentNotification(null)}
        />
      )}
    </>
  );
};
export default App;
